import React from 'react';

export const RadioButtonIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="white" stroke="#959595"/>
    </svg>
  );
};

export const RadioButtonIconFill = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="10" fill="#2b3990"/>
      <rect x="6.25" y="6.25" width="7.5" height="7.5" rx="3.75" fill="white"/>
    </svg>
  );
};
